export default {
  hasSms (state) {
    return state.features.find(f => f === 'SMS')
  },
  hasDial (state) {
    return state.features.find(f => f === 'DIAL')
  },
  noResults (state) {
    const hasZeroResults = state.searchResults.length === 0
    const isKeywordLongEnough = state.keyword.length >= 2
    return isKeywordLongEnough && !state.isSearching && hasZeroResults && state.hasSearched
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dialer/getters.js